(function () {
  var pages = Array.prototype.slice.call(document.querySelectorAll('[data-inventory-page]'));

  function normalize(value) {
    return String(value || '').toLowerCase().trim();
  }

  function getCardText(card) {
    return normalize([
      card.getAttribute('data-inventory-title'),
      card.textContent
    ].join(' '));
  }

  function getConsoleFilters(page) {
    var inputs = Array.prototype.slice.call(page.querySelectorAll('[data-inventory-console-filter]'));

    return {
      hasFilters: inputs.length > 0,
      selected: inputs.filter(function (input) {
        return input.checked;
      }).map(function (input) {
        return normalize(input.value);
      })
    };
  }

  function sortCards(page) {
    var sortEl = page.querySelector('[data-inventory-sort]');
    var sortValue = sortEl ? sortEl.value : 'title-asc';

    Array.prototype.slice.call(page.querySelectorAll('[data-inventory-category-items]')).forEach(function (itemsEl) {
      var cards = Array.prototype.slice.call(itemsEl.querySelectorAll('[data-inventory-card]'));
      cards.sort(function (left, right) {
        var leftTitle = normalize(left.getAttribute('data-inventory-title'));
        var rightTitle = normalize(right.getAttribute('data-inventory-title'));
        var leftDate = left.getAttribute('data-inventory-date') || '';
        var rightDate = right.getAttribute('data-inventory-date') || '';
        var result;

        if (sortValue === 'title-asc' || sortValue === 'title-desc') {
          result = leftTitle.localeCompare(rightTitle);
          return sortValue === 'title-desc' ? -result : result;
        }

        // Unknown sale dates remain last in either direction; receipts are not sale dates.
        if (!leftDate || !rightDate) return leftDate ? -1 : rightDate ? 1 : leftTitle.localeCompare(rightTitle);
        result = Date.parse(leftDate) - Date.parse(rightDate);
        if (sortValue === 'date-desc') result = -result;
        return result || leftTitle.localeCompare(rightTitle);
      });

      var currentCards = Array.prototype.slice.call(itemsEl.querySelectorAll('[data-inventory-card]'));
      var orderChanged = cards.some(function (card, index) {
        return card !== currentCards[index];
      });
      if (!orderChanged) return;

      cards.forEach(function (card) {
        itemsEl.appendChild(card);
      });
    });
  }

  function updatePage(page) {
    var searchEl = page.querySelector('[data-inventory-search]');
    var emptyEl = page.querySelector('[data-inventory-empty]');
    var query = normalize(searchEl ? searchEl.value : '');
    var consoleFilters = getConsoleFilters(page);
    var cards = Array.prototype.slice.call(page.querySelectorAll('[data-inventory-card]'));
    var visibleCount = 0;

    cards.forEach(function (card) {
      var consoleName = normalize(card.getAttribute('data-inventory-category'));
      var matchesQuery = !query || getCardText(card).indexOf(query) !== -1;
      var matchesConsole = !consoleFilters.hasFilters || consoleFilters.selected.indexOf(consoleName) !== -1;
      var isVisible = matchesQuery && matchesConsole;

      card.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    Array.prototype.slice.call(page.querySelectorAll('[data-inventory-category-items]')).forEach(function (itemsEl) {
      var categoryEmptyEl = itemsEl.nextElementSibling;
      var categoryCards = Array.prototype.slice.call(itemsEl.querySelectorAll('[data-inventory-card]'));
      var categoryVisibleCount = categoryCards.filter(function (card) {
        return !card.hidden;
      }).length;

      if (categoryEmptyEl && categoryEmptyEl.hasAttribute('data-inventory-category-empty')) {
        categoryEmptyEl.hidden = categoryVisibleCount > 0;
      }
    });

    if (emptyEl) {
      emptyEl.hidden = visibleCount > 0;
    }
  }

  pages.forEach(function (page) {
    var searchEl = page.querySelector('[data-inventory-search]');
    var consoleFilterEls = Array.prototype.slice.call(page.querySelectorAll('[data-inventory-console-filter]'));
    var sortEl = page.querySelector('[data-inventory-sort]');
    var filterMenuEl = page.querySelector('[data-inventory-filter-menu]');

    if (searchEl) {
      searchEl.addEventListener('input', function () {
        updatePage(page);
      });
    }

    consoleFilterEls.forEach(function (input) {
      input.addEventListener('change', function () {
        updatePage(page);
      });
    });

    if (sortEl) {
      sortEl.addEventListener('change', function () {
        sortCards(page);
        updatePage(page);
      });
    }

    if (filterMenuEl) {
      var wideFilters = window.matchMedia('(min-width: 1100px)');
      function syncFilterLayout() {
        page.querySelector('[data-inventory-tools]').classList.toggle('inventory-tools--inline', wideFilters.matches);
        filterMenuEl.open = wideFilters.matches;
        if (wideFilters.matches && document.activeElement === filterMenuEl.querySelector('summary')) sortEl.focus();
      }
      wideFilters.addEventListener('change', syncFilterLayout);
      syncFilterLayout();
      document.addEventListener('click', function (event) {
        if (wideFilters.matches) return;
        if (!filterMenuEl.open || filterMenuEl.contains(event.target)) return;
        filterMenuEl.open = false;
      });

      document.addEventListener('keydown', function (event) {
        if (wideFilters.matches) return;
        if (event.key !== 'Escape' || !filterMenuEl.open) return;
        filterMenuEl.open = false;
        filterMenuEl.querySelector('summary').focus();
      });
    }

    sortCards(page);
    updatePage(page);
  });
}());
